// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2TeRA","author":"Table_author__18URj","authorImage":"Table_authorImage__1x-ty","unreadRow":"Table_unreadRow__1xFAD"};